import size from "../sizes";
import digitalPrinting from "./templates/digital-printing";
import maintenance from "./templates/maintenance";

export default [
  {
    id: `material`,
    title: `Крой и качество материала`,
    content: {
      description: `<p>Платье с закругленным декольте и аккуратными короткими рукавами. Удобные карманы на уровне бёдер и незаметные швы позволяют расположить красивый и красочный принт наиболее выгодно. Слегка расклешено к низу. Ткань представляет собой смесь хлопка и микрофибры, поэтому платье достаточно гладкое, плотное, но струящееся.</p>`
    }
  },
  {
    id: `printing`,
    title: `Способ печати и уход`,
    content: {
      printingInfo: `${digitalPrinting}${maintenance}`
    }
  },
  {
    id: `size`,
    title: `Размерная сетка`,
    content: {
      table: size[`full_print_summer_dress`],
      sizeInfo: `summer_dress`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
